import { useEffect, useRef, useState } from 'react';
import { DASHBOARD_LIST_PAGE_SIZE } from '../services/dashboard/ordreDuJour';

export function useRevealOnScroll(
  itemCount: number,
  pageSize = DASHBOARD_LIST_PAGE_SIZE,
) {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const rootRef = useRef<HTMLDivElement>(null);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [itemCount, pageSize]);

  const hasMore = visibleCount < itemCount;

  useEffect(() => {
    const root = rootRef.current;
    const sentinel = sentinelRef.current;
    if (!root || !sentinel || !hasMore) return;

    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisibleCount((n) => n + pageSize);
        }
      },
      { root, rootMargin: '0px' },
    );
    io.observe(sentinel);
    return () => io.disconnect();
  }, [hasMore, pageSize, visibleCount]);

  return { visibleCount, rootRef, sentinelRef, hasMore };
}
